"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./Link.css");
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("..");
function Link(_a) {
    var children = _a.children, href = _a.href, _b = _a.target, target = _b === void 0 ? "_blank" : _b, _c = _a.appearance, appearance = _c === void 0 ? "default" : _c, _d = _a.underline, underline = _d === void 0 ? false : _d, Icon = _a.icon, _e = _a.iconPosition, iconPosition = _e === void 0 ? "start" : _e, _f = _a.iconSize, iconSize = _f === void 0 ? "small" : _f, _g = _a.disabled, disabled = _g === void 0 ? false : _g, _h = _a.spinner, spinner = _h === void 0 ? false : _h, download = _a.download, onClick = _a.onClick, _j = _a.size, size = _j === void 0 ? "base" : _j;
    var classname = (0, classnames_1.default)("nimbus--link", "nimbus--link--".concat(appearance), "nimbus--link--".concat(size), { "nimbus--link--underlined": underline }, { "nimbus--link--disabled": disabled }, { "nimbus--link--loading": spinner });
    var iconStartClass = (0, classnames_1.default)("nimbus--link__icon", {
        "nimbus--link__icon--start": iconPosition === "start" && children,
    });
    var iconEndClass = (0, classnames_1.default)("nimbus--link__icon", {
        "nimbus--link__icon--end": iconPosition === "end" && children,
    });
    var iconSpinner = spinner && React.createElement(__1.Spinner, null);
    var renderStartIcon = !spinner && Icon && iconPosition === "start" && (React.createElement("i", { className: iconStartClass },
        React.createElement(Icon, { size: iconSize })));
    var renderEndIcon = !spinner && Icon && iconPosition === "end" && (React.createElement("i", { className: iconEndClass },
        React.createElement(Icon, { size: iconSize })));
    var handleOnClick = function (event) {
        if (!href) {
            event.preventDefault();
        }
        event.stopPropagation();
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    return (React.createElement("a", { className: classname, href: href, onClick: handleOnClick, target: href && target, download: download },
        iconSpinner,
        renderStartIcon,
        children,
        renderEndIcon));
}
var Skeleton = function () { return React.createElement("div", { className: "nimbus--link-skeleton" }); };
Link.Skeleton = Skeleton;
exports.default = Link;
//# sourceMappingURL=index.js.map